<template>
	<v-container
		class="brightBackground"
		fluid
		style="min-height: 100%"
	>
		
		<v-container fluid style="max-width: 1000px;" class="pt-xs-0 pt-sm-0 pt-md-0 pt-lg-6">

			<v-row>

				<v-col class="pt-0 pa-0 ma-0">
					
					<v-subheader class="display-1 font-weight-bold ml-0 pl-1 pb-0 grey--text text--darken-3">Groups</v-subheader>

					<v-toolbar
						dense
						flat
						color="toolbarSecondary"
					>
						<v-btn
							color="iconTextColor"
							text
							small
							style="text-transform: none;"
							class="ml-n4"
							height="32"
							router to="/admin/newgroup"
						>
							<v-icon medium>mdi-animation</v-icon>
							<span class="ml-2">New project group</span>
						</v-btn>

					</v-toolbar>



					<v-card
						color="boxOnBrightBackground"
						flat
						class="pa-3 mb-4"
						v-for="client in clients" :key="client.name"
					>
						<div align="left" class="title primary--text text--darken-3 pb-2">{{client.name}}</div>
						<div align="left" :class="`${ (!!client.groups && client.groups.length === 0) ? '' : 'd-none' } body-2 primary--text text--darken-3 pb-2`">No groups for this client yet.</div>


						<!-- -------------------------------------------- -->
						<!--   Expansion panel -->
						<!-- -------------------------------------------- -->

						<v-expansion-panels multiple>

							<v-expansion-panel
								v-for="(group, i) in client.groups" :key="i"
							>
								<!-- Expanded panel header-->
								<v-expansion-panel-header color="grey lighten-4 primary--text text--darken-1">
									<b>{{ group.name }}</b>
								</v-expansion-panel-header>

								<!-- Expanded panel -->
								<v-expansion-panel-content>
									<v-container fluid class="pt-6 pb-0 px-1">

										<v-row>
											<v-col cols="8" xs="12" sm="12" md="8" xl="8" class="px-3 pb-0">
												<v-text-field
													label="Group name"
													v-model="group.name"
													outlined
													dense
												></v-text-field>
											</v-col>

											<v-col
												cols="4" xs="12" sm="12" md="4" xl="4" class="px-3 pb-0"
											>
												<v-select
													v-model="group.clientId"
													:items="clients"
													item-text="name"
													item-value="id"
													label="Client this group belongs to"
													outlined
													dense
												></v-select>
											</v-col>
										</v-row>


										<v-row>
											<v-col cols="8" xs="12" sm="12" md="8" xl="8" class="px-3 pb-0">
												<v-text-field
													label="Group variable name"
													v-model="group.variable"
													outlined
													dense
												/>
											</v-col>

											<v-col cols="4" xs="12" sm="12" md="4" xl="4" class="px-3 pb-0">
												<v-text-field
													label="Group key"
													v-model="group.key"
													disabled
													outlined
													dense
												/>
											</v-col>
										</v-row>

										<v-row class="mb-n3">
											<v-col align="right">
												<!-- <v-btn style="text-transform: none;" class="ml-3" small text @click="deleteGroup(group)">
													<v-icon medium class="pr-1">mdi-delete</v-icon>
													Delete group
												</v-btn>
												<v-btn style="text-transform: none;" class="ml-3" small text @click="saveGroup(group)">
													<v-icon medium class="pr-1">mdi-content-save</v-icon>
													Save changes
												</v-btn> -->
												<icon-text-button b-icon="mdi-delete" @click="deleteGroup(group)">Delete group</icon-text-button>
												<icon-text-button b-icon="mdi-content-save" @click="saveGroup(group)">Save changes</icon-text-button>
											</v-col>
										</v-row>

									</v-container>

								</v-expansion-panel-content>
							</v-expansion-panel>

						</v-expansion-panels>

					</v-card>

				</v-col>
			</v-row>
			
		</v-container>

	</v-container>
</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from '@/shift/agile';
import fb from '@/shift/fb';

export default
{
	name: 'Groups',

	// ----------------------------------
	//	VUE: Data and computed
	// ----------------------------------

	data: () =>
	({
		// Variable for filling the height between top toolbar and bottom
		clients: [],
		groups: [],
		firestoreLiveConnections: [],
		
	}),

	computed:
	{
		agile()
		{
			return agile;
		},
	},


	// ----------------------------------
	//	VUE: Watching things
	// ----------------------------------

	watch:
	{
		// ----------------------------------
		//	Check if clients got its groups updated
		// ----------------------------------

		groups: function()
		{
			this.propagateClientsWithGroups();
		}
	},

	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{

		// ----------------------------------
		//	Load client list and let it
		//  live reload!
		// ----------------------------------
		
		this.firestoreLiveConnections.push(

			fb.db.collection('clients').onSnapshot(res =>
			{
				const changes = res.docChanges();

				changes.forEach(change =>
				{

					// ----------------------------------
					//	Content added
					// ----------------------------------

					if (change.type === 'added')
					{
						this.clients.push(
						{
							...change.doc.data(),
							id: change.doc.id
						})
					}


					// ----------------------------------
					//	Content modified
					// ----------------------------------

					if (change.type === "modified")
					{
						for (let i = 0; i < this.clients.length; i++)
						{
							if (this.clients[i].id == change.doc.id)
							{
								var uD = change.doc.data();
								this.clients[i].name = uD.name;
								this.clients[i].variable = uD.variable;
								this.clients[i].prefix = uD.prefix;
								this.clients[i].key = uD.key;
								this.clients[i].id = change.doc.id;
							}
						}
					}


					// ----------------------------------
					//	Content deleted
					// ----------------------------------

					if (change.type === "removed")
					{
						for (let i = 0; i < this.clients.length; i++)
						{
							if (this.clients[i].id == change.doc.id)
							{
								this.clients.splice(i, 1);
							}
						}
					}
				});

				// ----------------------------------
				//	Sort alphabetically by name
				// ----------------------------------

				this.agile.sortBy(this.clients, 'name');


			},
			er =>
			{
				this.$root.$alert("Error", er.message);
			})
		);




		// ----------------------------------
		//	Load project group list and let it
		//  live reload!
		// ----------------------------------
		
		this.firestoreLiveConnections.push(

			fb.db.collection('project-groups').onSnapshot(res =>
			{
				const changes = res.docChanges();

				changes.forEach(change =>
				{

					// ----------------------------------
					//	Content added
					// ----------------------------------

					if (change.type === 'added')
					{
						this.groups.push(
						{
							...change.doc.data(),
							id: change.doc.id
						})
					}


					// ----------------------------------
					//	Content modified
					// ----------------------------------

					if (change.type === "modified")
					{
						for (let i = 0; i < this.groups.length; i++)
						{
							if (this.groups[i].id == change.doc.id)
							{
								var uD = change.doc.data();
								this.groups[i].name = uD.name;
								this.groups[i].variable = uD.variable;
								this.groups[i].prefix = uD.prefix;
								this.groups[i].clients = uD.clients;
								this.groups[i].id = change.doc.id;
							}
						}
					}


					// ----------------------------------
					//	Content deleted
					// ----------------------------------

					if (change.type === "removed")
					{
						for (let i = 0; i < this.groups.length; i++)
						{
							if (this.groups[i].id == change.doc.id)
							{
								this.groups.splice(i, 1);
							}
						}
					}
				});

				// ----------------------------------
				//	Sort alphabetically by name
				// ----------------------------------

				this.agile.sortBy(this.groups, 'name');

			},
			er =>
			{
				this.$root.$alert("Error", er.message);
			})
		);



	},

	mounted()
	{
		
	},


	// --------------------------------------------------------------------
	//
	//	VUE: Methods
	//
	// --------------------------------------------------------------------

	methods:
	{
		
		// ----------------------------------
		//	Structue group data into clients
		// ----------------------------------

		propagateClientsWithGroups()
		{
			for (let i = 0; i < this.clients.length; i++)
			{
				this.clients[i].groups = new Array();

				for (let j = 0; j < this.groups.length; j++)
				{
					if (this.clients[i].id == this.groups[j].clientId)
					{
						this.clients[i].groups.push(this.groups[j]);
					}
				}
			}

			// Todo: Uh... is this the best way to update the view after putting groups data into clients data?
			this.$forceUpdate();
			
		},


		// ----------------------------------
		//	Save client data
		// ----------------------------------
		
		saveGroup(group)
		{
			
			// Todo: Validate god damn it
			this.$root.$confirm('Careful', 'Changes in these settings can break project code and user access. Still want to change?', { color: 'warning' } )
			.then((confirm) =>
			{
				if (confirm)
				{
					// ----------------------------------
					//	Create client in Firebase
					// ----------------------------------

					fb.db.collection("project-groups").doc(group.id).update(
					{
						name: group.name,
						variable: group.variable,
						//prefix: group.prefix.toLowerCase(),
						clientId: group.clientId,
					})
					.then(() =>
					{
						this.$root.ai_app.snackbarText = 'Group updated';
						this.$root.ai_app.snackbarTimeout = 3000;
						this.$root.ai_app.snackbar = true;
					})
					.catch((error) =>
					{
						this.$root.$alert("Error", error.message);
					});
				}
			});
		},


		// ----------------------------------
		//	Delete client
		//  Todo: Should only delete if
		//        no group/projects are
		//        assigned.
		// ----------------------------------

		deleteGroup(group)
		{
			this.$root.$confirm('Careful', 'Deleting groups will make all projects in this group orphans. Still want to delete?', { color: 'warning' } )
			.then((confirm) =>
			{
				if (confirm)
				{
					fb.db.collection("project-groups").doc(group.id).delete()
					.then(() =>
					{
						this.$root.ai_app.snackbarText = 'Group deleted';
						this.$root.ai_app.snackbarTimeout = 3000;
						this.$root.ai_app.snackbar = true;
					})
					.catch((error) =>
					{
						this.$root.$alert("Error", error.message);
					});
				}
			});

		},
		
	},



	// --------------------------------------------------------------------
	//
	//	VUE: Destroy event hook
	//
	// --------------------------------------------------------------------
	
	beforeDestroy()
	{
		// Unsubscribe live listeners
		for (let i = 0; i < this.firestoreLiveConnections.length; i++)
		{
			this.firestoreLiveConnections[i]();
		}
	},


}
</script>